import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'rax_mexc_banner_dismissed';

export default function MEXCBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      className="w-full"
      style={{
        background: 'linear-gradient(90deg, #050c1f 0%, #0a1535 25%, #0c1d4a 50%, #071a3e 75%, #040c1c 100%)',
        borderBottom: '1px solid rgba(0, 212, 255, 0.2)',
        boxShadow: '0 1px 24px 0 rgba(0, 102, 255, 0.12)',
      }}
    >
      {/* Cyan accent line at very top */}
      <div
        className="h-[2px] w-full"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, #0066FF 20%, #00D4FF 50%, #0066FF 80%, transparent 100%)',
        }}
      />

      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 py-3 sm:py-2.5">

          {/* Left: message */}
          <div className="flex items-center gap-3">
            <span className="text-lg leading-none select-none" aria-hidden="true">🚀</span>
            <p className="text-[15px] sm:text-base font-semibold text-white leading-tight tracking-tight">
              <span
                className="font-bold"
                style={{ color: '#00D4FF' }}
              >
                $RAX
              </span>
              {' '}is now live on{' '}
              <span className="font-bold text-white">MEXC</span>
              <span className="hidden sm:inline text-white/50 font-normal text-sm ml-2">
                — Trade now on the global exchange
              </span>
            </p>
          </div>

          {/* Right: CTA + dismiss */}
          <div className="flex items-center gap-3 shrink-0">
            <a
              href="https://www.mexc.com/en-GB/exchange/RAX_USDT"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-bold text-white whitespace-nowrap transition-all duration-200"
              style={{
                background: 'linear-gradient(135deg, #0055dd 0%, #00bfef 100%)',
                boxShadow: '0 0 0 1px rgba(0, 212, 255, 0.3), 0 2px 12px rgba(0, 102, 255, 0.3)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.boxShadow = '0 0 0 1px rgba(0, 212, 255, 0.6), 0 0 20px rgba(0, 212, 255, 0.4)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.boxShadow = '0 0 0 1px rgba(0, 212, 255, 0.3), 0 2px 12px rgba(0, 102, 255, 0.3)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Buy $RAX
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true">
                <path d="M2 9L9 2M9 2H4M9 2V7" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>

            <button
              onClick={dismiss}
              aria-label="Dismiss banner"
              className="flex items-center justify-center w-7 h-7 rounded-full transition-all duration-150"
              style={{ color: 'rgba(255,255,255,0.35)' }}
              onMouseEnter={e => {
                e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.color = 'rgba(255,255,255,0.35)';
                e.currentTarget.style.background = 'transparent';
              }}
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
